import React, { useState, useEffect } from "react";
import LayoutV2 from "containers/LayoutV2";
import "react-dropdown/style.css";
import { Headersub } from "./headersub";
import { SearchBar } from "./SearchBar";
import { BtnThemMoi } from "./ThemMoi/BtnThemMoi";

// import { AddNhanVayDeskTopBtn } from "./AddNhanVayDesktop";
import { TableNhanVay } from "./TableNhanVay";
import { useSelector, useDispatch } from "react-redux";

import StoreApi from "../../service/phanQuyenApi";
import { ModelThietLapHienThi } from "./ModelThietLapHienThi";
import ThietLapHienThiApi from "../../service/QuanTriHeThong/ThietLapHienThiApi";
import { SearchBarMobile } from "./SearchBarMobile";
import { ModalTimKiemNangCao } from "./ModalTimKiemNangCao";
import { getListNhanVay, updateDataSearch } from "../../actions/NhanVay/";
import { ModalPhieuThu } from "./ChucNang/InPhieuThuChi/ModalPhieuThu";
import { ModalPhieuChi } from "./ChucNang/InPhieuThuChi/ModalPhieuChi";
import { TraLaiNhanVay } from "./ChucNang/TraLai/TraLaiNhanVay";
import PhanTrang from "components/CommonComponent/PhanTrang";

export const NhanVay = () => {
  const [choVay, setChoVay] = useState({});
  useEffect(() => {
    document.title = "Nhận vay | Phần mềm quản lý cầm đồ Morman";
  }, []);

  const dispatch = useDispatch();
  const listNhanVay = useSelector((state) => state.listNhanVay);
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  const initPhanQuyen = {
    camdo_sudungchoduyet: false, //
    camdo_thaydoitienlai: false, //
    nhanvay_danhsachnhanvay: false,
    nhanvay_ghichu: false,
    nhanvay_giahanhopdong: false,
    nhanvay_giahanngaytra: false,
    nhanvay_inhopdongnhanvay: false,
    nhanvay_suanhanvay: false,
    nhanvay_tattoannhanvay: false,
    nhanvay_themmoinhanvay: false,
    nhanvay_thongtinchitiethopdong: false,
    nhanvay_thongtinchitietkhachhang: false,
    nhanvay_trabotgoc: false,
    nhanvay_tralainhanvay: false,
    nhanvay_xoanhanvay: false,
    nhanvay_xuatexceldanhsachnhanvay: false,
    thuchihopdong_suaphieuthuchi: false, //
    thuchihopdong_xoaphieuthuchi: false, //
    nhanvay_suatientattoan: false,
  };
  const [isLoadRoleDone, setLoadRoleDone] = useState(false);
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [objThietLapHienThiDanhSach, setObjThietLapHienThiDanhSach] = useState(
    {}
  );
  const [isShowModalThietLapHienThi, setIsShowModalThietLapHienThi] =
    useState(false);
  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenNhanVay().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        camdo_sudungchoduyet: response.data.camdo_sudungchoduyet,
        camdo_thaydoitienlai: response.data.camdo_thaydoitienlai,
        nhanvay_danhsachnhanvay: response.data.nhanvay_danhsachnhanvay,
        nhanvay_ghichu: response.data.nhanvay_ghichu,
        nhanvay_giahanhopdong: response.data.nhanvay_giahanhopdong,
        nhanvay_giahanngaytra: response.data.nhanvay_giahanngaytra,
        nhanvay_inhopdongnhanvay: response.data.nhanvay_inhopdongnhanvay,
        nhanvay_suanhanvay: response.data.nhanvay_suanhanvay,
        nhanvay_tattoannhanvay: response.data.nhanvay_tattoannhanvay,
        nhanvay_themmoinhanvay: response.data.nhanvay_themmoinhanvay,
        nhanvay_thongtinchitiethopdong:
          response.data.nhanvay_thongtinchitiethopdong,
        nhanvay_thongtinchitietkhachhang:
          response.data.nhanvay_thongtinchitietkhachhang,
        nhanvay_trabotgoc: response.data.nhanvay_trabotgoc,
        nhanvay_vaythem: response.data.nhanvay_vaythem,
        nhanvay_tralainhanvay: response.data.nhanvay_tralainhanvay,
        nhanvay_xoanhanvay: response.data.nhanvay_xoanhanvay,
        nhanvay_xuatexceldanhsachnhanvay:
          response.data.nhanvay_xuatexceldanhsachnhanvay,
        thuchihopdong_suaphieuthuchi:
          response.data.thuchihopdong_suaphieuthuchi,
        thuchihopdong_xoaphieuthuchi:
          response.data.thuchihopdong_xoaphieuthuchi,
        nhanvay_suatientattoan:
          response.data.nhanvay_suatientattoan == undefined
            ? false
            : response.data.nhanvay_suatientattoan,
      });
      setLoadRoleDone(true);
    });
  };
  useEffect(() => {
    LoadPhanQuyen();
    getThietLapHienThi();
  }, []);
  const getThietLapHienThi = () => {
    ThietLapHienThiApi.thietLapDanhSachNhanVay().then((response) => {
      setObjThietLapHienThiDanhSach(response.data);
    });
  };
  const toggleModalThietLapHienThi = () => {
    setIsShowModalThietLapHienThi(!isShowModalThietLapHienThi);
  };
  const setModalThietLapHienThi = () => () => {
    toggleModalThietLapHienThi();
  };
  const [isShowTimKiem, setShowTimKiem] = useState(false);

  const setModalTimKiemNangCao = () => {
    toggleModalTimKiemNangCao();
  };

  const toggleModalTimKiemNangCao = () => {
    setShowTimKiem(!isShowTimKiem);
  };
  const onSearch = () => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: 1,
      })
    );
    dataSearch.pageIndex = 1;
    dispatch(getListNhanVay(dataSearch));
  };
  const initDataPrint = {
    ThuChiID: 0,
    hopdongId: 0,
    CVType: 0,
  };
  const [dataPrint, setDataPrint] = useState(initDataPrint);
  const [showPhieuThuChi, setShowPhieuThuChi] = useState(false);
  const handleClosePhieuThuChi = () => {
    setShowPhieuThuChi(false);
    handleShowTraLai(dataTraLai);
  };
  const printThuChi = (item, ThuChiID) => {
    setDataPrint({
      ...dataPrint,
      ThuChiID: ThuChiID,
      ChoVayID: item.NhanVayId,
    });

    setShowPhieuThuChi(true);
    handleCloseTraLai();
  };
  const [dataTraLai, setDataTraLai] = useState({});
  const [showTraLai, setShowTraLai] = useState(false);
  const handleCloseTraLai = () => setShowTraLai(false);
  const handleShowTraLai = (data) => {
    setShowTraLai(true);
    setDataTraLai(data);
  };
  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListNhanVay(dataSearch));
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    dispatch(updateDataSearch(data));
    dispatch(getListNhanVay(data));
  };
  return (
    <LayoutV2>
      {phanQuyen.nhanvay_danhsachnhanvay && isLoadRoleDone  && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <Headersub
                  title="Nhận vay"
                  icon="/app-assets/images/logo-cam-do-v2.png"
                  quyenThemMoi={phanQuyen.nhanvay_themmoinhanvay}
                />

                <SearchBar
                  onSearch={onSearch}
                  setModalThietLapHienThi={setModalThietLapHienThi}
                />
                <SearchBarMobile
                  onShow={setModalTimKiemNangCao}
                  onSearch={onSearch}
                />
              </div>
            </div>

            <div className="col-12">
              <div
                className="card border-light mb-1 card-v2"
                style={{
                  marginTop: "-35px",
                }}
              >
                {" "}
                <div className="card-body card-body-v2">
                  <div className="row col-sm-12 col-md-12 themoi-taisanthanhly hidden-mobile-main">
                    <BtnThemMoi
                      quyenThemMoi={phanQuyen.nhanvay_themmoinhanvay}
                    />
                  </div>
                </div>
                <TableNhanVay
                  listNhanVay={listNhanVay}
                  quyenGhiChu={phanQuyen.nhanvay_ghichu}
                  quyenGiaHanHopDong={phanQuyen.nhanvay_giahanhopdong}
                  quyenGiaHanNgayTra={phanQuyen.nhanvay_giahanngaytra}
                  quyenSuaNhanVay={phanQuyen.nhanvay_suanhanvay}
                  quyenTatToan={phanQuyen.nhanvay_tattoannhanvay}
                  quyenXemChiTietHopDong={
                    phanQuyen.nhanvay_thongtinchitiethopdong
                  }
                  quyenXemChiTietKhachHang={
                    phanQuyen.nhanvay_thongtinchitietkhachhang
                  }
                  quyenTraBotGoc={phanQuyen.nhanvay_trabotgoc}
                  quyenVayThem={phanQuyen.nhanvay_vaythem}
                  quyenTralai={phanQuyen.nhanvay_tralainhanvay}
                  quyenXoa={phanQuyen.nhanvay_xoanhanvay}
                  quyenThemMoi={phanQuyen.nhanvay_themmoinhanvay}
                  quyenInHopDong={phanQuyen.nhanvay_inhopdongnhanvay}
                  quyenXuatExcel={phanQuyen.nhanvay_xuatexceldanhsachnhanvay}
                  quyenSuaTienTatToan={phanQuyen.nhanvay_suatientattoan}
                  choVay={choVay}
                  setChoVay={setChoVay}
                  objThietLapHienThiDanhSach={objThietLapHienThiDanhSach}
                  printThuChi={printThuChi}
                  handleShowTraLai={handleShowTraLai}
                />
              </div>
            </div>

            <div className="col-12">
              <div className="card border-light mb-3 card-v2">
                <div className="card-body card-body-v2">
                  <PhanTrang
                    pageIndex={dataSearch.pageIndex}
                    pageSize={dataSearch.pageSize}
                    totalCount={listNhanVay.objList.TongBanGhi}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                  />
                </div>
              </div>
            </div>
          </div>{" "}
          {isShowModalThietLapHienThi && (
            <ModelThietLapHienThi
              show={isShowModalThietLapHienThi}
              onHide={toggleModalThietLapHienThi}
              data={objThietLapHienThiDanhSach}
              getThietLapHienThi={getThietLapHienThi}
            />
          )}
          {isShowTimKiem == true && (
            <ModalTimKiemNangCao
              show={isShowTimKiem}
              onHide={toggleModalTimKiemNangCao}
              onSearch={onSearch}
            />
          )}
          {dataPrint.Value > 0
            ? showPhieuThuChi && (
                <ModalPhieuThu
                  show={showPhieuThuChi}
                  onHide={handleClosePhieuThuChi}
                  id={dataPrint.ThuChiID}
                  CVType={0}
                  // inthuchi={inthuchi}
                  // inPhieuThu={inPhieuThu}
                />
              )
            : showPhieuThuChi && (
                <ModalPhieuChi
                  show={showPhieuThuChi}
                  onHide={handleClosePhieuThuChi}
                  id={dataPrint.ThuChiID}
                  hopdongId={dataPrint.ChoVayID}
                  CVType={0}
                  // inthuchi={inthuchi}
                  inPhieuChi={true}
                />
              )}
          {showTraLai && (
            <TraLaiNhanVay
              show={showTraLai}
              onHide={handleCloseTraLai}
              nhanvayId={dataTraLai.ID}
              NguoiNhan={dataTraLai.TenChuNo}
              item={dataTraLai}
              printThuChi={printThuChi}
            />
          )}
        </div>
      )}
      {!phanQuyen.nhanvay_danhsachnhanvay && isLoadRoleDone  && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <Headersub
                  title="Nhận vay"
                  icon="/app-assets/images/icon-camdo.png"
                />
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
